/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PasswordChange = {
    properties: {
        password: {
            type: 'string',
            isRequired: true,
        },
    },
} as const;
